import ForecastsFiltersApp from "./forecasts/forecasts_filters_app";
import TariffSurveyHubApp from "./tariff_survey_hub/app";
import RegulationParameterApp from "./regulations/parameters/app";
import RegulationAllApp from "./regulations/regulations/app";
import RegulationStandardApp from "./regulations/standards/app";
import CountryRegulationsTableApp from "./chart_templates/country_regulations_table/app";
import AfricaRegionPageMapApp from "./chart_templates/africa_region_page_map/app";
import IndicatorTableApp from "./admin/indicator_table/app";
import UkTotexChart from "./chart_templates/uk_totex_chart/app";
import UtilitiesDashboardApp from "./utilities_dashboard/main";
import UsStateForecast from "./chart_templates/us_state_forecast/app";
import DigiIndustrialForecastTriple from "./chart_templates/digi_industrial_forecast_triple/app";
import UtilitiesNr from "./chart_templates/utilities_nr/app";

const ReactApps = {
  ForecastsFiltersApp,
  TariffSurveyHubApp,
  RegulationParameterApp, RegulationAllApp, RegulationStandardApp,
  CountryRegulationsTableApp,
  AfricaRegionPageMapApp,
  UkTotexChart,
  IndicatorTableApp,
  UtilitiesDashboardApp,
  UsStateForecast,
  DigiIndustrialForecastTriple,
  UtilitiesNr
};
export default ReactApps;
